import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../../../icons/SvgToIcon";
import { ReactComponent as AutoRemediationIcon } from "../../../../../../../scenes/stack/environment/icons/auto-fix-icon.svg";
import { ReactComponent as BreezeLogoDisabled } from "../../../../../../../scenes/stack/environment/icons/breeze_logo_disabled.svg";
import { ReactComponent as BreezeLogo } from "../../../../../../../scenes/stack/environment/icons/sidebar_icons/side-bar-logo-collapsed.svg";
import { RemediationStatus } from "../../../../../../../utils/constants";
import AutoRemediationWizard from "./wizard/AutoRemediationWizard";

export default function AutoRemediationButton({ fullControl, remediation }) {
  const colors = useColors();
  const [showWizard, setShowWizard] = useState(false);
  let enabled =
    remediation.has_autofix &&
    remediation.status !== RemediationStatus.RESOLVED;

  return (
    <>
      <CustomTooltip
        title={enabled && "Click to review and approve changes before applying"}
        placement="top"
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          height="32px"
          padding="0 8px"
          sx={{
            borderRadius: "10px",
            border: `1px solid ${
              enabled
                ? colors.button_outlined_inherit_enabled_stroke
                : colors.button_outlined_disabled_stroke
            }`,
            backgroundColor: enabled
              ? colors.button_outlined_inherit_enabled_bg
              : colors.button_outlined_disabled_bg,
            cursor: enabled ? "pointer" : "auto",
            ...(enabled && {
              "&:hover": {
                borderColor: colors.button_outlined_inherit_hovered_stroke,
                backgroundColor: colors.button_outlined_inherit_hovered_bg,
              },
            }),
          }}
          onClick={enabled ? () => setShowWizard(true) : undefined}
        >
          <SvgToIcon
            IconLogo={AutoRemediationIcon}
            width="16px"
            height="16px"
            style={{
              color: enabled
                ? colors.button_outlined_inherit_enabled_icon
                : colors.button_outlined_disabled_icon,
            }}
          />
          <Typography
            variant="overline"
            sx={{
              userSelect: "none",
              color: enabled
                ? colors.button_outlined_inherit_enabled_text
                : colors.button_outlined_disabled_text,
            }}
          >
            Auto-remediation
          </Typography>
          <SvgToIcon
            IconLogo={enabled ? BreezeLogo : BreezeLogoDisabled}
            width="16px"
            height="16px"
          />
        </Box>
      </CustomTooltip>
      <AutoRemediationWizard
        showWizard={showWizard}
        setShowWizard={setShowWizard}
        remediation={remediation}
        fullControl={fullControl}
      />
    </>
  );
}
